import { IrTableComponent } from './ir-table.component';
import { PrRescueComponent } from './pr-rescue/pr-rescue.component';
import { AnticipatedRescueComponent } from './anticipated-rescue/anticipated-rescue.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateISOStringPipeModule } from '../../pipes';

@NgModule({
    imports: [
        CommonModule,
        DateISOStringPipeModule,
    ],
    exports: [
        IrTableComponent,
        PrRescueComponent,
        AnticipatedRescueComponent,
    ],
    declarations: [
        IrTableComponent,
        PrRescueComponent,
        AnticipatedRescueComponent,
    ],
})
export class IrTableModule { }
